// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"ContextMenu_contextMenu__1fWFt","red":"ContextMenu_red__uaSU6","primary":"ContextMenu_primary__3olui"};